import React from 'react';
import './single-side-nav.scss';

export interface SingleSideNavProps {
  id: string;
  label: string;
  currentActiveNav: string;
}

export default function SingleSideNav(props: SingleSideNavProps) {
  return (
    <div className={`single-side-nav-container ${props.currentActiveNav === props.id ? 'active' : ''}`}>
      <div className="single-side-nav-contents">
        <div className="side-nav-text">{props.label}</div>
        <div className="side-nav-icons"></div>
      </div>
    </div>
  );
}
